import 'scss/solutions/intelligent-vehicle-system.scss'
import 'babel-polyfill'
import 'js/libs/utils-solutions'



// WEBPACK FOOTER //
// ./src/js/entry/solutions/intelligent-vehicle-system.js